// extracted by mini-css-extract-plugin
export default {"title":"_2-FXm","lockIcon":"_2IIUc"};